import script from "./tologin.vue?vue&type=script&setup=true&lang=js"
export * from "./tologin.vue?vue&type=script&setup=true&lang=js"

import "./tologin.vue?vue&type=style&index=0&id=6f416658&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f416658"]])

export default __exports__